// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".message[data-v-cab3b514]{margin-top:8px;padding-left:102px;font-size:12px;color:red}.form-item-wrap[data-v-cab3b514]{display:flex}.form-item-wrap label[data-v-cab3b514]{width:72px;height:30px;display:flex;flex-direction:column;justify-content:center;margin-right:30px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
